import { Autocomplete, TextField } from '@mui/material';
import FilterWrapper from './FilterWrapper';
import { countriesOptions } from '@utils/globalOptions';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { closeOptions } from '@utils/utils';

export const CountryFilter = ({
    filterField,
    addFilter,
    filters,
    setFilter,
    ...rest
}) => {
    const { t } = useTranslation();
    const {
        control,
        formState: { isValid }, // required to rerennder the apply button
        handleSubmit,
    } = useForm({ shouldUnregister: true });

    if (!rest.open) return null;
    const { name } = filterField;

    const onSubmit = data => {
        setFilter(`${name}__in`, data[name]);
        rest.onClose();
        closeOptions();
    };

    const selectedCountries = filters?.[`${name}__in`] || [];

    const getCountryOptions = (countryCodes: string[]) => {
        if (!countryCodes) return;
        return countriesOptions.filter(option =>
            countryCodes.includes(option.value),
        );
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <FilterWrapper
                title={filterField.label}
                name={name}
                control={control}
                {...rest}
            >
                <Controller
                    name={name}
                    control={control}
                    render={({ field: { value, onChange, ...field } }) => {
                        return (
                            <Autocomplete
                                multiple
                                id="country-filter"
                                options={countriesOptions}
                                sx={{ width: 300 }}
                                limitTags={3}
                                defaultValue={getCountryOptions(
                                    selectedCountries,
                                )}
                                value={getCountryOptions(value)}
                                onChange={(_, newValue) =>
                                    onChange(
                                        newValue.map(option => option.value),
                                    )
                                }
                                {...field}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        autoFocus
                                        label={t('Country')}
                                        placeholder={t('Select Country')}
                                    />
                                )}
                            />
                        );
                    }}
                />
            </FilterWrapper>
        </form>
    );
};

export default CountryFilter;
